// extracted by mini-css-extract-plugin
export default {"root":"Home_root__gA75z","flex1":"Home_flex1__42SEN","map":"Home_map__h9kOE","homeBtn":"Home_homeBtn__QpPny","bannerContainer":"Home_bannerContainer__QoY67"};